// Vue
import {mixins} from 'vue-class-component'
import {Vue, Component, Prop, Inject} from 'vue-property-decorator'

// Template
import template from './template.vue'

// Components
import {Icon} from './../../icon/Icon'

// Mixins
import {EventBus} from '../../../../mixins/event_bus/EventBus'

@Component({
    name: 'DropdownOption',
    components: {Icon},
    mixins: [
        template,
    ]
})
export class DropdownOption extends mixins(EventBus) {

    @Inject({ from: 'dropdownTheme'})
    public theme!: string

    @Prop([String, Number, Boolean])
    public label!: any

    @Prop()
    public href!: string

    @Prop()
    public to!: object

    @Prop()
    public target!: string

    @Prop()
    public iconName!: string

    @Prop()
    public iconFile!: string

    @Prop()
    public iconSize!: string

    @Prop({default: false})
    public disabled!: boolean

    public created() {

    }

    public handleClick(e: Event) {

        if (this.disabled) {
            e.preventDefault()
            e.stopPropagation()
            return
        }

        this.$emit('click', e)
    }
}